@if (navigationItems?.length > 0) {
  <div class="flex flex-row p-ai-center"
       [class.pb-2]="!subNavigation" [class.lg:pb-3]="!subNavigation"
       [class.border-bottom-1]="subNavigation"
       [class.border-gray-800]="subNavigation"
       [class.shadow-3]="subNavigation">
    <span class="p-buttonset flex w-full">
      @for (menuItem of navigationItems; track menuItem) {
        <p-button [routerLink]="menuItem.routerLink"
                  (onClick)="onItemChanged.emit(menuItem)"
                  [styleClass]="menuItem.styleClass + ' w-full justify-content-center pushbutton' + (subNavigation ? ' subPushbutton' : '')"
                  class="flex-1">
          <div class="align-items-center justify-content-center gap-2" [class.flex]="!view.isMobile960 || showMobileLabels">
            <span [class.icon-pushbutton]="!subNavigation" [class.icon-pushbutton-subPushbutton]="subNavigation"
                  [class]="menuItem.icon"></span>

            @if (!view.isMobile960 || showMobileLabels) {
              <div>
                {{ menuItem.label | translate }}
              </div>
            }
            @if (menuItem.iconClass === 'PRO') {
              <i class="pi pi-lock text-sm"></i>
            }
          </div>
        </p-button>
      }
    </span>
  </div>
}
